import {useAppSelector} from "@Hooks/selector/useAppSelector";
import {useLazyHandleStripePaymentQuery} from "@CheckOrder/api/checkOrderApi";
import {UpdatePassengerClassesResponseType} from "@CheckOrder/api/types/UpdatePassengerClassesQuery.type";

type StripePaymentParams = {
    privacyPolicyChecked: boolean,
    newsletterAccepted: boolean,
    tripReviewAccepted: boolean,
}

export default function useHandleStripePayment(params: StripePaymentParams) {
    const [handleStripePaymentQuery] = useLazyHandleStripePaymentQuery()

    const {
        newsletterAccepted,
        tripReviewAccepted,
        privacyPolicyChecked,
    } = params

    const {
        phoneCountryObject,
        phoneNumber,
        email,
        stripeEnabled,
        ticket: {
            ticketCode,
            priceInHrk,
            purchaseMaxTimestamp,
            ancillariesData,
            singleSelectedAmenities,
            returnSelectedAmenities,
        },
        tokens: {
            ipgFormToken,
        },
        selectedServices: {
            isBuyingPremiumSupport,
            isBuyingSMSNotification,
            isBuyingTier1FlexibleCancellation,
        },
    } = useAppSelector((state) => state.checkOrder)

    const convertToTinyInt = (value: boolean) => (value ? 1 : 0)

    const handleStripePayment = (updatedCheckOrderData?: UpdatePassengerClassesResponseType | null) => {
        const {
            checkOrder,
        } = updatedCheckOrderData || {}

        const {
            ticket: updatedTicketData,
        } = checkOrder || {}

        handleStripePaymentQuery({
            order_number: ticketCode,
            customer_email: email,
            // todo #hrk2eur #adomjanovic #llalic
            // @ante you should probably rename this to priceInEur as HRK is gone
            amount: updatedTicketData?.priceInHrk ?? priceInHrk,
            best_before: purchaseMaxTimestamp,
            customer_phone: phoneNumber,
            country: phoneCountryObject?.isoCode,
            proceed_to_ipg_payment_form: 1,
            stripe_enabled: convertToTinyInt(stripeEnabled),
            gbb_tos_and_privacy_policy: convertToTinyInt(privacyPolicyChecked),
            gbb_ticket_trip_review: convertToTinyInt(tripReviewAccepted),
            gbb_newsletter: convertToTinyInt(newsletterAccepted),
            ancillary_data: {
                gbb_is_buying_premium_support: isBuyingPremiumSupport,
                premiumSupportPrice: ancillariesData.premiumSupport.price,
                gbb_is_buying_sms_notification: isBuyingSMSNotification,
                smsNotificationPrice: ancillariesData.smsNotification.price,
                gbb_is_buying_tier1_flexible_cancellation: isBuyingTier1FlexibleCancellation,
                tier1FlexibleCancellationPrice: ancillariesData.tier1FlexibleCancellation.price,
            },
            single_selected_amenities: singleSelectedAmenities,
            return_selected_amenities: returnSelectedAmenities,
            _token: ipgFormToken,
        })
    }

    return {
        handleStripePayment,
    }
}